class FilterHelper {
    workbookConfig: WorkbookConfig;
    constructor(workbookConfig: WorkbookConfig) {
        this.workbookConfig = workbookConfig;
    }

    updateDrilldownFilters() {
        this.update(true);
    }

    updateFilters() {
        this.update(false);
    }

    private update(isDrilldown) {
        let self = this;
        let comparisonFilterChanged = false;
        let workbookFilters = isDrilldown ? [] : this.workbookConfig.filters().filter(x => x.isDirty() || x.removed());
        workbookFilters.forEach(self.beforeApplyFilter);

        let tabFilters = [];
        this.workbookConfig.tabs().forEach(function (tab: WorkbookTab) {
            let tabFiltersChanged = (isDrilldown ? tab.drilldownManager.getActiveDrillViewItem().filters() : tab.filters()).filter(x => x.isDirty() || x.removed());
            tabFiltersChanged.forEach(self.beforeApplyFilter);

            let comparisonFilters = null;
            if (tab.reportConfig) {
                let reportConfig = isDrilldown ? tab.drilldownManager.activeReportConfig : tab.reportConfig;
                let comparisonFilterTabChanged = false;
                reportConfig.comparisonFilters().forEach(x => {
                    if (x.isDirty()) {
                        comparisonFilterTabChanged = true;
                        if (tab.isActiveTab()) {
                            comparisonFilterChanged = true;
                        }
                    }
                    x.isDirty(false);
                });
                comparisonFilters = comparisonFilterTabChanged ? ko.toJS(reportConfig.comparisonFilters()) : [];
            }

            let tabFilterVM = {
                tabId: tab.id(),
                drilldownId: tab.drilldownManager?.isDrilldown && isDrilldown ? tab.drilldownManager.activeDrilldownId : -1,
                filters: tabFiltersChanged.filter(x => x.isDirty() && !x.removed()),
                filtersRemoved: tabFiltersChanged.filter(x => x.removed()).map(x => x.id()),
                widgetFilters: [],
                get hasFiltersChanged() {
                    return this.filters.length > 0 || this.filtersRemoved.length > 0 || (this.comparisonFilters && this.comparisonFilters.length > 0);
                },
                comparisonFilters: comparisonFilters
            };

            if (tab.tabType() === TabTypeEnum.Dashboard && tab.isDashboardLoaded) {
                for (var dashboardWidget of tab.dashboard.widgets()) {
                    let widgetFiltersChanged = (isDrilldown ? dashboardWidget.drilldownManager.getActiveDrillViewItem().filters() : dashboardWidget.filters()).filter(x => x.isDirty() || x.removed());
                    if (!isDrilldown && dashboardWidget.widgetType() === WidgetType.Filter && dashboardWidget.widget?.result) {
                        if (dashboardWidget.widget.result.filter?.isDirty()) {
                            widgetFiltersChanged.push(dashboardWidget.widget.result.filter);
                        }
                    }

                    widgetFiltersChanged.forEach(self.beforeApplyFilter);

                    let comparisonFilters = null;
                    if (dashboardWidget.reportConfig) {
                        let reportConfig = isDrilldown ? dashboardWidget.drilldownManager.activeReportConfig : dashboardWidget.reportConfig;
                        let comparisonFilterWidgetChanged = false;
                        reportConfig.comparisonFilters().forEach(x => {
                            if (x.isDirty()) {
                                comparisonFilterWidgetChanged = true;
                                if (dashboardWidget.isSelected) {
                                    comparisonFilterChanged = true;
                                }
                            }
                            x.isDirty(false);
                        });
                        comparisonFilters = comparisonFilterWidgetChanged ? ko.toJS(reportConfig.comparisonFilters()) : [];
                    }

                    tabFilterVM.widgetFilters.push({
                        widgetId: dashboardWidget.id(),
                        drilldownId: dashboardWidget.drilldownManager?.isDrilldown && isDrilldown ? dashboardWidget.drilldownManager.activeDrilldownId : -1,
                        filters: widgetFiltersChanged.filter(x => x.isDirty() && !x.removed()),
                        filtersRemoved: widgetFiltersChanged.filter(x => x.removed()).map(x => x.id()),
                        get hasFiltersChanged() {
                            return this.filters.length > 0 || this.filtersRemoved.length > 0 || (this.comparisonFilters && this.comparisonFilters.length > 0);
                        },
                        comparisonFilters: comparisonFilters
                    });
                }
            }

            tabFilters.push(tabFilterVM);
        });

        let o = {
            url: urlConfigs.filters + "UpdateFilters",
            data: ko.toJS({
                workbookId: workbook.workbookConfig.workbookId(),
                workbookFilters: workbookFilters.filter(x => x.isDirty() && !x.removed()),
                workbookFiltersRemoved: workbookFilters.filter(x => x.removed()).map(x => x.id()),
                tabFilters: tabFilters.filter(x => x.hasFiltersChanged || (x.widgetFilters.length > 0 && x.widgetFilters.some(x => x.hasFiltersChanged)))
            }),
            dataType: "json",
            async: false,
            removeNullProperties: false
        } as RequestServerParams;

        o.successFunction = function (this: FilterHelper, data: { tabs: Array<{ id: number, filters: Array<any>, widgets: Array<{ id: number, filters: Array<any> }> }> }) {
            let workbookFiltersChanged = workbookFilters.length > 0;

            if (!isDrilldown) {
                self.workbookConfig.filters.remove(x => x.removed());

                for (let filter of self.workbookConfig.filters().filter(x => x.added() || x.isDirty())) {
                    filter.added(false);
                    filter.isDirty(false);
                }
            }

            self.workbookConfig.tabs().forEach((tab) => {
                let workbookTabFilters = isDrilldown ? tab.drilldownManager.getActiveDrillViewItem().filters : tab.filters;
                workbookTabFilters.remove(x => x.removed());
                for (let filter of workbookTabFilters().filter(x => x.added() || x.isDirty())) {
                    filter.added(false);
                    filter.isDirty(false);
                }

                let returnedTab = data.tabs.find(x => x.id === tab.id());
                if (returnedTab) {
                    for (let returnedFilter of returnedTab.filters) {
                        let tabFilter = workbookTabFilters().find(x => x.id() === returnedFilter.id);
                        if (tabFilter) {
                            self.afterApplyFilter(tabFilter, returnedFilter);
                        }
                    }
                }

                if (tab.tabType() === TabTypeEnum.Dashboard && tab.isDashboardLoaded) {
                    for (var dashboardWidget of tab.dashboard.widgets()) {
                        let dashboardWidgetFilters = isDrilldown ? dashboardWidget.drilldownManager.getActiveDrillViewItem().filters : dashboardWidget.filters;
                        dashboardWidgetFilters.remove(x => x.removed());

                        for (let filter of dashboardWidgetFilters().filter(x => x.added() || x.isDirty())) {
                            filter.added(false);
                            filter.isDirty(false);
                        }

                        if (returnedTab) {
                            let returnedWidget = returnedTab.widgets.find(x => x.id === dashboardWidget.id());
                            if (returnedWidget) {
                                for (let returnedWidgetFilter of returnedWidget.filters) {
                                    let widgetFilter = dashboardWidgetFilters().find(x => x.id() === returnedWidgetFilter.id);
                                    if (widgetFilter) {
                                        self.afterApplyFilter(widgetFilter, returnedWidgetFilter);
                                    }
                                }
                            }
                        }
                    }
                }

                //refresh only what is necessary
                let tabFilter = tabFilters.find(x => x.tabId === tab.id());
                if (workbookFiltersChanged || tabFilter?.hasFiltersChanged || tabFilter?.widgetFilters?.find(x => x.hasFiltersChanged)) {
                    if (tab === self.workbookConfig.activeTab()) {
                        if (workbookFiltersChanged || tabFilter?.hasFiltersChanged) {
                            if (isDrilldown) {
                                tab.drilldownManager.refresh();
                            }
                            else {
                                tab.refresh();
                            }
                        }
                        else {
                            let widgetsToUpdate: Array<DashboardWidget> = [];
                            for (var widget of tab.dashboard.widgets()) {
                                let widgetFilter = tabFilter.widgetFilters.find(x => x.widgetId === widget.id());
                                if (widgetFilter && widgetFilter.hasFiltersChanged) {
                                    if (widget.widgetType() === WidgetType.Filter) {
                                        tab.refresh();
                                        widgetsToUpdate = [];
                                        break;
                                    }

                                    widgetsToUpdate.push(widget);
                                }
                            }

                            for (let widget of widgetsToUpdate) {
                                if (isDrilldown) {
                                    widget.drilldownManager.refresh();
                                }
                                else {
                                    widget.refresh();
                                }
                            }
                        }
                    }
                    else {
                        tab.forceRefresh(true);
                    }
                }
            });

            if (!isDrilldown) {
                self.workbookConfig.workbookHelper.applyFiltersDisabled(true);
            }

            if (comparisonFilterChanged) {
                Ir.Components.ReportDesigner.ReportDesigner.reload(self.workbookConfig.activeTabOrWidget());
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to apply filters`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    private beforeApplyFilter(filter: Filter) {
        if (filter.removed()) {
            return;
        }

        if (filter.beforeApplyFilter) {
            filter.beforeApplyFilter();
        }
        else {
            if (filter.filterEditorType() === FilterEditorTypeEnum.AutoComplete || filter.filterEditorType() === FilterEditorTypeEnum.MultiSelect) {
                if (!filter.requireDataSourceUpdate() && filter.dataSource() && filter.dataSource().length && filter.multipleCondition() &&
                    filter.dataSource().length === filter.multipleCondition().length) {
                    filter.multipleCondition([]);
                }
            }
        }
    }

    private afterApplyFilter(filter: Filter, returnedFilter) {
        filter.requireDataSourceUpdate(true);
        filter.multipleCondition(returnedFilter.multipleCondition);
        filter.dataSourceLength(returnedFilter.dataSourceLength);
        filter.startDisplayCondition(returnedFilter.startDisplayCondition);
        filter.startCondition(returnedFilter.startCondition);
        filter.endCondition(returnedFilter.endCondition);
    }
}